<template>
  <div class="col-12 col-md-6 form-group form-group-sm">
    <label class="label" for="sensorDeMovimiento">Sensor de Movimiento</label>
    <input
      v-model="sensorDeMovimiento"
      :class="`form-control form-control-sm text-center${
        isOk ? '' : ' is-invalid'
      }`"
      min="0"
      step="15"
      type="number"
    />
  </div>
</template>

<script>
export default {
  name: "SensorDeMovimiento",
  data: () => ({}),
  computed: {
    isOk() {
      try {
        return this.sensorDeMovimiento % 15 === 0;
      } catch (e) {
        return false;
      }
    },
    sensorDeMovimiento: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.sensorDeMovimiento;
      },
      set(val) {
        this.$store.commit(
          "Contratos/NuevoContrato/setSensorDeMovimiento",
          val,
        );
      },
    },
  },
};
</script>

<style scoped></style>
